import {
  formatRenewalAmount,
  formatRenewNote,
} from "@/components/shared/interval-switch/plan-period-copy";
import { BILLING_INTERVAL } from "@/data/constants";
import { TPlanPriceAmount } from "@/types/plan-data";
import { TAddOn, TPlan } from "../types.checkout";
import {
  buildOwnedAddOnCartItems,
  buildOwnedCartItems,
  getFounderPriceOverride,
} from "./derivedData";
import { TAddOnItem } from "./getAddOnItemList";
import { sumItemPrices } from "./renewal-amount";

/** What the switch-to-yearly card names and renews at, priced at the yearly rate. */
export const buildSwitchIntervalCopy = ({
  ownedPlanList,
  ownedAddOnItemList,
  addOnCards,
  currency,
  renewsAt,
  isFounder,
  planPriceAmount,
}: {
  ownedPlanList: TPlan[];
  ownedAddOnItemList: TAddOnItem[];
  addOnCards: TAddOn[];
  currency: string;
  renewsAt: string;
  isFounder: boolean | undefined;
  planPriceAmount?: TPlanPriceAmount;
}) => {
  const yearlyPlans = buildOwnedCartItems(
    ownedPlanList,
    BILLING_INTERVAL.YEARLY,
    getFounderPriceOverride(isFounder, planPriceAmount),
  );
  const yearlyAddOns = buildOwnedAddOnCartItems(
    ownedAddOnItemList,
    addOnCards,
    BILLING_INTERVAL.YEARLY,
  );
  const planName = yearlyPlans.map((plan) => plan.name).join(" + ");
  const renewalAmount = sumItemPrices(
    [...yearlyPlans, ...yearlyAddOns],
    currency,
  );

  // An unpriced line would read "NA"; leave the amounts off instead.
  if (renewalAmount === undefined) {
    return { planName };
  }

  return {
    planName,
    subtotal: formatRenewalAmount(renewalAmount, currency),
    renewNote: formatRenewNote(
      renewsAt,
      renewalAmount,
      currency,
      BILLING_INTERVAL.YEARLY,
    ),
  };
};
